import { Box, Checkbox, Column, Columns, Control, Field, Input, Select } from "@allxsmith/bestax-bulma";
import React from "react";

export default function Supplier({ contact, handleChange, handleCheckbox }) {
  return (
    <Box>
      <h1 className="title">Supplier Details</h1>
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label">Supplier Labour Rate</label>
            <Control>
              <Input
                type="number"
                name="supplier_labour_charge"
                onChange={handleChange}
                value={String(contact.supplier_labour_charge)}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Supplier LCV Labour Rate</label>
            <Control>
              <Input
                type="number"
                name="lcv_rate"
                onChange={handleChange}
                value={String(contact.lcv_rate)}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Labour Rate Affected By Customer Markup %</label>
            <input
              className="checkbox"
              type="checkbox"
              name="labour_rate_affected_by_customer_markup"
              onChange={handleCheckbox}
              checked={contact.labour_rate_affected_by_customer_markup}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Stock Kept At Supplier</label>
            <Checkbox
              checked={contact.stock_kept_at_supplier}
              name={"stock_kept_at_supplier"}
              onChange={handleCheckbox}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Payment Terms</label>
            <Input
                name={"supplier_payment_terms"}
                type={"text"}
                value={contact.supplier_payment_terms}
                onChange={handleChange}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Payment Terms Start</label>
            <Select
              value={contact.supplier_payment_terms_start}
              name={"supplier_payment_terms_start"}
              onChange={handleChange}
            >
              <option key={0} value={"DATE"}>Invoice Date</option>
              <option key={1} value={"MONTH"}>Month End</option>
            </Select>
          </Field>
        </Column>
      </Columns>
    </Box>
  );
}
